export function activeOptSubType(props, editFlow) {
  const { event } = props;

  return Object.keys(editFlow?.options).find((key) => key === event.subType);
}
